import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {}, // ユーザー情報
    rooms: [], // 取得したルームを入れる配列
  	rooms_in: [],
    drawer: true,
  },
  getters: {
    user(state) {
      return state.user
    },
    getRooms(state) {
      return state.rooms
    },
  	getRoomsIn (state) {
  	  return state.rooms_in
  	},
  },
  actions: {
    resetRooms ({commit}) {
      commit('resetRooms')
    },
    roomAdded ({commit}, snap) {
      commit('roomAdded', snap)
    },
    changeRoom ({commit}, changed_room) {
      commit('changeRoom', changed_room)
    },
    roomRemoved ({commit}, snap) {
      commit('roomRemoved', snap)
    },
  	doEnterRoom ({commit}, rooms_in) {
  	  commit('doEnterRoom', rooms_in)
  	},
    doExitRoom ({commit}, key) {
      commit('doExitRoom', key)
    },
    switchDrawer ({commit}, resize) {
      commit('switchDrawer', resize)
    }
  },
  mutations: {
    onAuthStateChanged(state, user) {
      state.user = user //firebaseが返したユーザー情報
    },
    resetRooms (state) {
      state.rooms = []
    },    
    roomAdded (state, snap) {
      state.rooms.push({
        key: snap.key,
        name: snap.val().name,
        owner: snap.val().owner
      })
    },    
    changeRoom (state, changed_room) {
      state.rooms[changed_room.index].name = changed_room.name
      if(changed_room.index_in != -1) state.rooms_in[changed_room.index_in].name = changed_room.name
    },
    roomRemoved (state, snap)  {
      const index = state.rooms.findIndex((v) => v.key === snap.key)
      if(index != -1) state.rooms.splice(index, 1)
    },
  	doEnterRoom (state, rooms_in) {
      const index = state.rooms_in.findIndex((v) => v.link === rooms_in.link)
      if(index === -1){
        state.rooms_in.push({
          link: rooms_in.link,
          name: rooms_in.name
        })        
      }
  	},
    doExitRoom (state, key) {
      const index = state.rooms_in.findIndex((v) => v.link === key)
      if(index != -1) state.rooms_in.splice(index, 1)
    },
    switchDrawer (state, resize){
      if(resize != null){
        state.drawer = resize
      }
      else{
        state.drawer = !state.drawer 
      }
    }
  },
  modules: {
  },
  plugins: [createPersistedState()] //ブラウザを閉じてもstateを保持
})
